// removed by extract-text-webpack-plugin
module.exports = {"image_sizewrapper":"image_sizewrapper__aSC4s"};


//////////////////
// WEBPACK FOOTER
// ./components/PictureGallery/style.scss
// module id = CeE8
// module chunks = 17